import { X, Check } from "lucide-react";
import { COMPARISON } from "@/data/content";
import { Reveal, MaskReveal, SectionLabel } from "./primitives";

export default function ComparisonSection() {
  return (
    <section className="relative bg-brand-mist py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="mb-14 max-w-3xl">
          <Reveal><SectionLabel>POR QUE O INTENSIVO?</SectionLabel></Reveal>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-brand-navy sm:text-4xl lg:text-5xl">
            <MaskReveal lines={["Uma preparação diferente", "de um cursinho generalista."]} />
          </h2>
        </div>

        <div className="grid items-stretch gap-5 md:grid-cols-2">
          {/* Left — without direction */}
          <Reveal>
            <div className="h-full rounded-3xl border border-brand-navy/8 bg-white/60 p-7 md:p-9">
              <span className="inline-flex rounded-full bg-brand-navy/5 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy/45">
                {COMPARISON.left.title}
              </span>
              <ul className="mt-7 space-y-4">
                {COMPARISON.left.items.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand-navy/5 text-brand-navy/35">
                      <X className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm text-brand-navy/55 line-through decoration-brand-navy/20 md:text-base">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Right — Intensivo (highlighted) */}
          <Reveal delay={0.12}>
            <div className="relative h-full overflow-hidden rounded-3xl border border-brand-gold/40 bg-brand-navy p-7 text-white shadow-[0_40px_80px_-30px_rgba(10,25,47,0.5)] md:p-9">
              <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
              <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-brand-gold/20 blur-3xl" />
              <span className="relative inline-flex rounded-full bg-brand-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-navy">
                {COMPARISON.right.title}
              </span>
              <ul className="relative mt-7 grid gap-4 sm:grid-cols-2">
                {COMPARISON.right.items.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand-gold/20 text-brand-gold">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm font-medium text-white/90 md:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
